import { __assign } from "tslib";
// DS: I3.11
import React from 'react';
import IconWrap from '../../IconWrap';
var More = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 10a2 2 0 110 4 2 2 0 010-4zm7 0a2 2 0 110 4 2 2 0 010-4zm7 0a2 2 0 110 4 2 2 0 010-4z", clipRule: "evenodd" })))); };
More.displayName = 'More';
export default More;
//# sourceMappingURL=More.js.map